const typoUserMyAccount = {
  title: 'My account',
  config: 'Settings',
  profileError: 'Wait for the file to upload',
  name: 'Name',
  password: 'Password',
  label: 'Receive automatic emails',
  automaticEmailsHelperTitle: 'This setting controls whether you receive the following emails:',
  automaticEmailsHelperWeeklyServicesReport: 'Weekly services report',
  automaticEmailsHelperWeeklyActionsReport: 'Weekly actions report',
  automaticEmailsHelperActionCompleted: 'Action completion, sent to its creator (and admins, when the feature flag is enabled)',
  automaticEmailsHelperActionAssigned: 'Action creation, sent to its accountables',
  coordinatesLabel: 'Show service report coordinates, map and created at',
};

export default typoUserMyAccount;
